import React from 'react';
import { IFileRecord } from '@abstract/abstractwebcommon-shared/interfaces/license/fileRecord';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

interface IDownloadPageFormPropertiesInterface {
  fileRecord: IFileRecord;
  downloadFile: (file: any) => void;
  returnToFiles: () => void;
}

const DownloadPageForm = (properties: IDownloadPageFormPropertiesInterface): JSX.Element => {
  const { fileRecord, downloadFile, returnToFiles } = properties;
  const footer: JSX.Element = (
    <div className="d-flex justify-content-between">
      <Button
        label="Return to files"
        icon="pi pi-arrow-left"
        className="p-button-danger p-ml-2"
        onClick={returnToFiles}
      />{' '}
      <Button
        label="Download"
        icon="pi pi-download"
        className="p-button-success p-ml-2"
        onClick={() => downloadFile(fileRecord)}
      />
    </div>
  );

  return (
    <div className="download-info card-center">
      <Card className="p-mt-5 w-100" footer={footer}>
        <div className="headerContainer">
          {fileRecord.icon && <img src={fileRecord.icon} className="fixed-img" />}
          <div className={`header justify-content-center ${fileRecord.icon ? 'left-margin' : ''}`}>
            <div className="d-flex .flex-column p-card-title">
              <span className="align-end">{fileRecord.name}</span>
            </div>
            <div className="p-card-subtitle">{fileRecord.website}</div>
          </div>
        </div>
        <p className="p-m-0" style={{ lineHeight: '1.5' }}>
          {fileRecord.description}
        </p>
      </Card>
    </div>
  );
};

export default DownloadPageForm;
